export default "__VITE_ASSET__Dp8Vi2Dc__"